
<header
    *ngIf="!isEntryPage"
    [userName]="preferredName"
    [userNameAs]="authAsName"
    [isUserAs]="isUserAs"
    (logout)="logout()"
    (logoutAs) = "logOutAs()">
</header>

<div  [ngClass]="{wrap: !isEntryPage}" [class.wrap--entry]="isEntryPage">
    <div [ngClass]="{'container-fluid': !isEntryPage}">
        <router-outlet></router-outlet>
    </div>
</div>

<app-toasts></app-toasts>
